import { AttendResponseType } from "../../../../types/block/enum";
import { BlockVisibilityType } from "../../../../types/block/enum";
import { RSVPMenu } from "../../../../views/TaskDetail/RSVP/RSVPMenu";
import VisibilityDropdown from "../VisibilityDropdown";
import PriorityDropdown from "../PriorityDropdown";
import CalendarDropdown from "../CalendarDropdown";
import MoreDropdown from "../MoreDropdown";

interface HeaderMenuProps {
  toggleExpand: boolean;
  isEvent: boolean;
  taskDetail: any;
  currentRSVPValue: AttendResponseType;
  handleChangeRSVP: (value: AttendResponseType) => void;
  visibilityDropdownRef: React.RefObject<HTMLDivElement>;
  selectedVisibilityType: BlockVisibilityType;
  handleVisibilityDropdownItemClick: (value: string) => void;
  priorityDropdownRef: React.RefObject<HTMLDivElement>;
  onChangePriority: (value: string) => void;
  calendarDropdownRef: React.RefObject<HTMLDivElement>;
  fetchEditableUserCalendarsQuery: any;
  handleMoveCalendar: (value: string) => void;
  isDisabled: boolean;
  moreModalRef: React.RefObject<HTMLDivElement>;
  onDataDuplicate: (e: Event) => void;
  handleTaskDelete: () => void;
  isShowUserCalendar: boolean;
  isTask: boolean;
  isInboxGeneralBlock: boolean;
}

// 헤더 메뉴 컴포넌트
const HeaderMenu = ({
  toggleExpand,
  isEvent,
  taskDetail,
  currentRSVPValue,
  handleChangeRSVP,
  visibilityDropdownRef,
  selectedVisibilityType,
  handleVisibilityDropdownItemClick,
  priorityDropdownRef,
  onChangePriority,
  calendarDropdownRef,
  fetchEditableUserCalendarsQuery,
  handleMoveCalendar,
  isDisabled,
  moreModalRef,
  onDataDuplicate,
  handleTaskDelete,
  isShowUserCalendar,
  isTask,
  isInboxGeneralBlock,
}: HeaderMenuProps) => {
  return (
    <div className="flex flex-shrink-0 items-center gap-2">
      {toggleExpand && isEvent && taskDetail.data?.attendees?.length > 0 && (
        <RSVPMenu
          currentValue={currentRSVPValue}
          onChangeValue={handleChangeRSVP}
        />
      )}

      {!isInboxGeneralBlock && (
        <VisibilityDropdown
          visibilityDropdownRef={visibilityDropdownRef}
          selectedVisibility={selectedVisibilityType}
          onValueChange={handleVisibilityDropdownItemClick}
        />
      )}

      {isTask && (
        <PriorityDropdown
          priorityDropdownRef={priorityDropdownRef}
          selectedPriority={taskDetail.data.priority}
          onValueChange={onChangePriority}
        />
      )}

      {isShowUserCalendar && (
        <CalendarDropdown
          calendarDropdownRef={calendarDropdownRef}
          selectedValue={
            taskDetail.data.calendarId?.toString() ?? taskDetail.data.calendar?.id?.toString()
          }
          calendarList={fetchEditableUserCalendarsQuery.data}
          onSelect={handleMoveCalendar}
        />
      )}

      {!isDisabled && (
        <MoreDropdown
          moreDropdownRef={moreModalRef}
          onDataDuplicate={onDataDuplicate}
          onTaskDelete={handleTaskDelete}
        />
      )}
    </div>
  );
};

export default HeaderMenu;
